import React, { useState } from 'react';
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    SelectChangeEvent,
    styled,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { CollectionItemsViewSelector } from './CollectionItemsViewSelector';
import SelectStyled from '../shared/SelectStyled';
import { COLLECTION_SORT_KEYS } from '../../utils/constans/collectionSortKeys';
import { useTranslation } from 'react-i18next';

const StyledBox = styled(Box)(({ theme }) => ({
    padding: '20px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

export const CollectionActionWrapper: React.FC<ActionsProps> = (props) => {
    const { selectedLayout, handleSelectLayout, handleSortSelect } = props;
    const [sort, setSort] = useState('BEST_SELLING');
    const { t } = useTranslation('collection');
    const theme = useTheme();
    const isLgBreakpoint = useMediaQuery(theme.breakpoints.down('lg'));
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleChange = (event: SelectChangeEvent) => {
        const sortItem = COLLECTION_SORT_KEYS.find(
            (elem) => elem.id == event.target.value
        );
        setSort(event.target.value as string);
        handleSortSelect(sortItem);
    };

    return (
        <Grid container alignItems="center" sx={{ paddingBottom: '10px' }}>
            {isLgBreakpoint && (
                <Grid item xs>
                    {t('COLLECTIONS.FILTER')}
                </Grid>
            )}
            {!isMobile && (
                <Grid item xs>
                    <>
                        <CollectionItemsViewSelector
                            handleSelectLayout={handleSelectLayout}
                            selectedLayout={selectedLayout}
                        />
                    </>
                </Grid>
            )}
            <Grid item xs>
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <FormControl variant="filled">
                        <InputLabel
                            sx={{
                                color: '#999999',
                            }}
                        >
                            {t('COLLECTIONS.SORT_LABEL')}
                        </InputLabel>
                        <SelectStyled
                            label={t('COLLECTIONS.SORT_LABEL').toString()}
                            value={sort}
                            onChange={handleChange}
                        >
                            {COLLECTION_SORT_KEYS.map((sortItem) => (
                                <MenuItem key={sortItem.id} value={sortItem.id}>
                                    {t(
                                        'COLLECTIONS.SORTS.' +
                                            sortItem.displayTranslate
                                    )}
                                </MenuItem>
                            ))}
                        </SelectStyled>
                    </FormControl>
                </Box>
            </Grid>
        </Grid>
    );
};

type ActionsProps = {
    selectedLayout: string;
    handleSelectLayout: (id: string) => void;
    handleSortSelect: (sort) => void;
};
